import Vue from 'vue'
import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import i18n from '@/lang'
import website from '@/config/website'
import ElOverlayAutoClose from '@/plugins/plugins.el.overlay.auto.close.js'

import crudCommon from '@/mixins/crud.js'
window.$crudCommon = crudCommon

Vue.prototype.website = website

Vue.use(Element, {
  i18n: (key, value) => i18n.t(key, value)
})
Vue.use(window.AVUE, {
  i18n: (key, value) => i18n.t(key, value)
})

Vue.use(ElOverlayAutoClose)

if (process.env.NODE_ENV === 'production') {
  if (window && window.console) {
    window.console.log = () => {}
  }
}
